class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.fetchSearchResults = this.fetchSearchResults.bind(this);
    this.displayResults = this.displayResults.bind(this);
    this.debouncedFetch = debounce(this.fetchSearchResults, 300);
  }

  connectedCallback() {
    const input = this.querySelector('input[type="search"]');
    const results = this.querySelector('.search-form__results');

    if (!input ||!results) return;

    input.addEventListener('input', (event) => {
      const query = event.target.value;
      this.debouncedFetch(query, results);
    })

    this.addEventListener('focusout', (event) => {
      if (!event.relatedTarget || !event.relatedTarget.closest('search-form')) {
        results.innerHTML = '';

        setTimeout(() => {
          input.value = '';
        }, 1000);
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.relatedTarget || event.relatedTarget.closest('search-form') != this) {
        results.innerHTML = '';

        setTimeout(() => {
          input.value = '';
        }, 200);
      }
    });
  }

  async fetchSearchResults(query, resultsEl) {
    if (!query) {
      resultsEl.innerHTML = '';
      return;
    }

    const searchUrl = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&section_id=header-predictive-search`;

    try {
      const response = await fetch(searchUrl);
      const data = await response.text();

      this.displayResults(data, resultsEl);
    } catch (error) {}
  }

  displayResults(data, resultsEl) {
    const resultsMarkup = new DOMParser()
      .parseFromString(data, 'text/html')
      .querySelector('#header-predictive-search-results').innerHTML

    resultsEl.innerHTML = resultsMarkup
  }
}

customElements.define('search-form', SearchForm);
